"use client";

/**
 * Desktop's InsuraBotIcon mark with LIVING EYES: they glance left, glance
 * right, and blink on a lazy loop — pure CSS, same paths as the static icon
 * so the silhouette stays identical to the sidebar mark.
 */
export function AnimatedInsuraBotIcon({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 500 410"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M386.363 22.731H113.636C88.5321 22.731 68.1814 43.0816 68.1814 68.1855V250.004C68.1814 275.108 88.5321 295.458 113.636 295.458H386.363C411.467 295.458 431.818 275.108 431.818 250.004V68.1855C431.818 43.0816 411.467 22.731 386.363 22.731Z"
        stroke="currentColor"
        strokeWidth="45.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7263 386.371H477.272"
        stroke="currentColor"
        strokeWidth="45.4545"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* eyes: outer group glances, inner group blinks */}
      <g className="ibot-glance">
        <g className="ibot-blink">
          <path
            d="M204.546 113.636V159.091"
            stroke="currentColor"
            strokeWidth="45.4545"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M295.454 113.636V159.091"
            stroke="currentColor"
            strokeWidth="45.4545"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
